export const DAYS_OF_WEEK = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

export const LS_KEYS = {
  DEP: 'Dep',
  REPORT_DATE_FROM: 'ReportDateFrom',
  REPORT_DATE_TO: 'ReportDateTo',
  VISIBLE: 'visible',
  DRTS: 'Drts',
  REPORTS: 'Reports',
  USER: 'User',
  GROUP_NAME: 'groupName',
  REPORT_DATE: 'ReportDate',
  GROUP_ID: 'ReportGroupId'
};
export const REPORT_RELOAD_LOADING_KEY = 'DEAL_PAYROLL_REPORT_RELOADING';
export const REPORT_RELOAD_ERROR_KEY = 'DEAL_PAYROLL_REPORT_RELOAD_ERROR';

export const VISIBILITY_STATE = {
  SHOW: 'show',
  HIDE: 'hide'
};

export const REPORT_MODES = {
  GROUP: 'group'
};

export const CSS_CLASSES = {
  HIDE: 'hide',
  NAVBAR: 'navbar-dark',
  CONTAINER: 'hide-ili-nehide'
};

export type TooltipType = 'wageRate' | 'salarySupplements';

export const TOOLTIP_TYPES = {
  WAGE_RATE: 'wageRate' as TooltipType,
  SALARY_SUPPLEMENTS: 'salarySupplements' as TooltipType
};

export const REPORT_DATE_LENGTH = 10;
export const REPORT_DATE_START_INDEX = 0;

export const EMPTY_TEXT = '';
export const HTTP_LINK_PREFIX = 'http';
export const INDEX_NOT_FOUND = -1;
export const FIRST_INDEX = 0;
export const PLANFIX_CALCULATION_LABEL_KEY = 'PLANFIX_CALCULATION';
export const PLANFIX_DEAL_CALCULATION_LABEL_KEY = 'PLANFIX_DEAL_CALCULATION';
export const PAYROLL_ICON_MARGIN = 10;
export const NUMBER_VALUE_TYPE = 'number';
export const DEAL_PAYROLL_DECIMAL_PLACES = 1;
export const ROLE_HEAD = 'ROLE_HEAD';
export const ROLE_ADMIN = 'ROLE_ADMIN';
export const ROUTE_ID_PARAM = 'id';
export const CONTEXT_MENU_X_OFFSET = 550;
export const CONTEXT_MENU_Y_OFFSET = 100;
export const EMPTY_CALENDAR_DAY = 0;
export const SUNDAY_INDEX = 0;
export const MONDAY_NUMBER = 1;
export const MONTH_NUMBER_OFFSET = 1;
export const NEXT_MONTH_OFFSET = 1;
export const LAST_DAY_OF_MONTH = 0;
export const DATE_PAD_LENGTH = 2;
export const DATE_PAD_CHARACTER = '0';
export const DATE_SEPARATOR = '-';
export const DAYS_IN_WEEK = 7;
export const EXCEL_MIME_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export const EXCEL_FILENAME_HEADER = 'filename';
export const DEFAULT_EXCEL_FILENAME = 'report.xlsx';
export const DOWNLOAD_LINK_TAG = 'a';
export const WORK_DAYS_ERROR_MESSAGE = 'Error fetching work days';
export const VACATION_ERROR_MESSAGE = 'Error fetching vacation data:';
export const EXCEL_ERROR_MESSAGE = 'Error generating Excel:';
export const EMPTY_TOOLTIP_CONTENT = '';
export const TOOLTIP_EMPTY_AMOUNT = '&mdash;';
export const TOOLTIP_LABEL_SEPARATOR = ': ';
export const TOOLTIP_SPACE = ' ';
export const TOOLTIP_LINE_BREAK = '<br>';
export const TOOLTIP_DOUBLE_LINE_BREAK = '<br><br>';
export const TOOLTIP_ADD_PREFIX = '+ ';
export const TOOLTIP_EQUALS_PREFIX = '= ';
export const TOOLTIP_DIVIDE_PREFIX = '/ ';
export const TOOLTIP_MULTIPLY_PREFIX = '* ';
export const TOOLTIP_ACTUAL_SEPARATOR = '&nbsp;|&nbsp;';
export const TOOLTIP_SPAN_END = '</span>';
export const TOOLTIP_COLORED_SPAN_START = '<span style="color: ';
export const TOOLTIP_COLORED_SPAN_MIDDLE = '">';
export const TOOLTIP_RED_SPAN_START = "<span style='color: red !important'>";
export const GUARANTEED_BASE_KEY = 'DEAL_PAYROLL_GUARANTEED_BASE';
export const PAYABLE_TASK_AMOUNT_KEY = 'DEAL_PAYROLL_PAYABLE_TASK_AMOUNT';
export const CALCULATED_TASK_AMOUNT_KEY = 'DEAL_PAYROLL_CALCULATED_TASK_AMOUNT';
export const PRE_MODIFIER_BASE_KEY = 'DEAL_PAYROLL_PRE_MODIFIER_BASE';
export const CURRENCY_CONVERSION_NOTE_KEY = 'DEAL_PAYROLL_TASK_CURRENCY_CONVERSION_NOTE';
export const MODIFIERS_UNAVAILABLE_KEY = 'DEAL_PAYROLL_MODIFIERS_UNAVAILABLE_AFTER_REFRESH';
export const MODIFIERS_FROM_REPORT_KEY = 'DEAL_PAYROLL_MODIFIERS_FROM_REPORT_AFTER_REFRESH';
export const FINAL_SALARY_KEY = 'DEAL_PAYROLL_FINAL_SALARY';
export const PREVIEW_FINAL_SALARY_KEY = 'DEAL_PAYROLL_PREVIEW_FINAL_SALARY';
export const CALCULATION_BASE_PAY_KEY = 'C_B_P';
export const CALCULATION_HOURS_KEY = 'V_S_O';
export const HOUR_KEY = 'HOUR';
export const USER_PAY_RATE_KEY = 'USER_PAY_RATE';
export const TOTAL_WORKING_HOURS_KEY = 'TOTAL_WORKING_HOURS_PER_MONTH';
export const ACTUAL_TIME_WORKED_KEY = 'ACTUAL_TIME_WORKED';
export const ALL_TIME_KEY = 'ALL_TIME';
export const TOTAL_AMOUNT_KEY = 'TOTAL_AMOUNT';
export const SCHEDULE_TITLE_FALLBACK = 'N/A';
export const SCHEDULE_WORK_PREFIX = 'Work: ';
export const SCHEDULE_REST_SEPARATOR = ' / Rest: ';
export const SCHEDULE_PERIOD_SEPARATOR = ' | ';
export const SCHEDULE_TITLE_START_PREFIX = 'Start work: ';
export const SCHEDULE_TITLE_END_PREFIX = ' - End work: ';
export const SCHEDULE_TITLE_PERIOD_PREFIX = '  Period: ';

export const PAYROLL_CALCULATION_INDEX = {
  BASE_RATE: 0,
  PLANNED_HOURS: 1,
  ACTUAL_HOURS: 2,
  ALL_HOURS: 3,
  CALCULATED_WAGE: 4,
  FIRST_MODIFIER: 5,
  LAST_MODIFIER: 11,
  MONTHLY_BONUS: 12,
  FULL_SALARY: 13,
  INTERNAL_SHARE: 14
};

export const PAYROLL_MODIFIERS = [
  {key: 'PUNISHMENT_FOR_NOT_WORKING_TIME', index: 5},
  {key: 'PUNISHMENT_FOR_BEING_LATE', index: 6},
  {key: 'PUNISHMENT_OR_REWARD_FOR_KARMA', index: 7},
  {key: 'R_F_S_L', index: 8},
  {key: 'R_F_T', index: 9},
  {key: 'R_F_LS', index: PAYROLL_CALCULATION_INDEX.LAST_MODIFIER}
];

export const TOOLTIP_COLORS = {
  GREEN: 'green',
  GREY: 'grey'
};

export const CONTEXT_MENU_INITIAL_POSITION = {
  x: 0,
  y: 0
};



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/my-working-report/my-working-report.constants.ts